<template lang="pug">
  .main-modal-mask.relative.z-400(v-if="isShow" @click.self="closeModal()")
    .main-modal-block.absolute.transform(class=" -translate-x-1/2 top-1/5 left-1/2" )
      .mdoal-content-box.m-auto(:style="{'padding': padding, 'max-width' :  maxWidth}")
        .modal-header
          slot(:name="custom_header" v-if="custom_header")
          .flex.justify-between(v-else)
            div {{headerTitle}}
            span.pt-20.cursor-pointer(@click="closeModal('X')") 
              iCon.h-24.w-24.text-grey-border(iconClass="close" type="svg")
        .modal-body
          slot(:name="body" v-if="body")
          div(v-else) 
            div {{bodyContent}}
        .modal-footer
          slot(:name="footer" v-if="footer")
</template>

<script>
// import Button from '@/components/Button.vue';
import { globalFixed } from '@/utils/mixin'

export default {
  name: 'Alert',
  components: {
    // Button,
  },
  props: {
    type: String,
    show: {
      type: Boolean,
      required: true,
      default: false
    },
    headerTitle: String,
    bodyContent: String,
    custom_header: String,
    body: String,
    footer: String,
    clickOutSideClose: {
      type: Boolean,
      default: true,
    },
    padding: String,
    maxWidth:{
      type: String,
      default: '500px',
    }
  },
  mixins: [globalFixed],
  data() {
    return {
      isShow: this.show,
    };
  },
  mounted(){
    this.isShow = this.show;
  },
  methods: {
    closeModal(word, type = ''){
      if(this.clickOutSideClose || type != '' || word){
          this.isShow = false;
      }else{
        this.isShow = true;
      }
      this.$emit('closeModal', this.isShow);
    },
  },
  watch:{
    'show': function (n){
      this.isFixed(n, 'fixed');
      // this.$root.frozen  = n ; 
      this.isShow = this.show
    }
  }
};
</script>

<style lang="scss" scoped>

.main-modal-mask{
  width: 100vw;
  @apply  fixed top-0 right-0 bottom-0 left-0 bg-modal;
  .main-modal-block{
    @apply block m-auto w-full;
    .mdoal-content-box{
      @apply bg-white shadow-modal py-36 px-36 rounded-8 w-full;
    }
  }
}

</style>